<template>
  <div>
    <!-- label -->
    <div v-if="label" class="label mb-3" >{{ label }}</div>

    <!-- input -->
    <div>
      <treeselect
        :style="cssVars"
        :class="'tree-long-item'"
        :limit="1"
        :limitText="limitText"
        :show-count="true"
        :searchable="true"
        v-model="value"
        :close-on-select="true"
        :placeholder="placeholder"
        :multiple="true"
        :load-options="loadOptions"
        :options="options"
        :auto-load-root-options="false"
        :flat="true"
        :value-consists-of="'ALL'"
      >
        <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
          <span :class="'tree-long-item'">
            {{  node.label }}
          </span>
          <span class="inline-block" v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
        </label>
      </treeselect>
    </div>

    <!-- error span -->
    <span class="text-danger text-sm block mt-2">{{ errors.first(this.errorCorrelationKey) }}</span>

    <!-- hint span-->
    <span v-if="!errors.first(this.errorCorrelationKey) && this.hint" class="speakol-color text-sm block mt-2">{{ hint }}</span>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import tree from '@/helpers/tree'

export default {
  name: 'speakol-checkbox-tree',
  components: {
    Treeselect
  },
  data () {
    return {
      errorCorrelationKey: '',
      value: null,
      options: null,
      flatIds: [],
      ALL_ID: -1
    }
  },
  created () {
    if (this.label) {
      this.errorCorrelationKey = this.label.toLowerCase()
    }
  },
  props: {
    'label': {
      default: '',
      type: [String, Number]
    },
    'placeholder': {
      default: 'placeholder',
      type: [String, Number]
    },
    'fetchFunction': {
      type: [Function]
    },
    'hint': {},
    'singleMaxWidth': {
      default: '230px'
    },
    'multipleMaxWidth': {
      default: '200px'
    },
    'includeAll': false
  },
  watch: {
    value: {
      handler (newVal, oldVal) {
        this.includesAll(newVal, oldVal)

        if (newVal.length > 1 && newVal.length !== this.flatIds.length) {
          const index = newVal.indexOf(this.ALL_ID)

          if (index !== this.ALL_ID) {
            newVal.splice(index, 1)
          }
        }

        this.$emit('input', newVal)
      },
      deep: true
    }
  },
  computed: {
    cssVars () {
      return {
        '--width': this.value && this.value.length > 1 ? this.multipleMaxWidth : this.singleMaxWidth
      }
    }
  },

  methods: {
    includesAll (newVal, oldVal) {
      // Check if all is selected
      if (!newVal) {
        return []
      }
      if (
        (!oldVal && newVal.includes(this.ALL_ID)) ||
        (newVal.includes(this.ALL_ID) && !oldVal.includes(this.ALL_ID))
      ) {
        this.value = this.flatIds
      } else if (
        // Check if all is deselected
        (oldVal && !newVal.includes(this.ALL_ID) && oldVal.includes(this.ALL_ID)) ||
        (oldVal && oldVal.includes(this.ALL_ID) && !newVal.includes(this.ALL_ID))
      ) {
        this.value = []
      }
    },
    limitText (count) {
      if (this.value.includes(this.ALL_ID)) {
        return ' '
      }
      return `+ ${count}`
    },
    setDefault () {
      this.value = []
      this.errors.clear()
    },

    //todo make this code more explict
    async loadOptions () {
      this.options = await this.fetchFunction()

      if (this.includeAll && this.options.length > 0) {
        this.options = [{id: this.ALL_ID, label: 'All'}, ...this.options]
      }
      this.flatIds = await tree.getIds(this.options)
    },

    async callFetchFunction () {
      this.setDefault()
      this.options = await this.fetchFunction(...arguments)
      if (this.includeAll && this.options && this.options.length !== 0) {
        this.options = [{id: this.ALL_ID, label: 'All'}, ...this.options]
      }

      this.flatIds = await tree.getIds(this.options)
    }
  }
}
</script>


<style lang="scss" scoped>
  .label {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    color: #2c2c2c;
  }

  .speakol-color {
    color: #0092d7;
  }

  /deep/ .vue-treeselect__control {
    height: 40px;
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.15);
    box-sizing: border-box;
    border-radius: 4px;
  }

  /deep/ .vue-treeselect__control-arrow-container {
    display: none;
  }

  /deep/ .vue-treeselect__x-container {
    display: none;
  }

  .tree-long-item /deep/ .vue-treeselect__multi-value-label {
    overflow: hidden;
    max-width: var(--width);
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  /deep/ .vue-treeselect__label {
    overflow: visible;
    text-overflow: unset;
  }

  /deep/ .vue-treeselect__menu {
    width: inherit;
    overflow-x: auto;
  }

  .tree-long-item /deep/ .vue-treeselect__option--highlight {
    background: #fff !important;
  }

  .vue-treeselect--has-value /deep/ .vue-treeselect__multi-value {
    height: 30px !important;
  }
</style>
